import React from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {connect} from 'react-redux';
import {Header, Dimmer, Loader, Segment, Form, Button} from 'semantic-ui-react';
import CommentList from 'go/components/comments/CommentList';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import ApiActions from 'go/actions/api';
import {API_COMMENT_POST_SUCCESS} from 'common/types';
import {getSubOrganizationId} from 'common/utils';

const EXCLUSIONS = ['panel-review', 'panelReview'];
const emptyStr = '';

export class SubComment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: emptyStr,
      comment: emptyStr,
      userComments: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  renderNoComments() {
    const {noCommentsText} = this.props;
    return <p>{noCommentsText || 'There are no comments on this subgrant.'}</p>;
  }

  renderComments = (data) => {
    const {entityType} = this.props;
    const noCommentsView = this.renderNoComments();

    if (_.get(data, 'loading')) {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    } else if (data && !_.isEmpty(data)) {
      return <CommentList comments={data} entityType={entityType} />;
    } else {
      return noCommentsView;
    }
  };

  handleChange(e) {
    const {name, value} = e.target;
    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();
    const {subject, comment} = this.state;
    let {entityId, programId, organizationId, entityType} = this.props;
    programId = _.toString(programId);
    if (subject && comment) {
      // TODO remove OpenAPI toggle code
      let response = this.props.saveSubComment(
        this.props.token,
        this.props.userId,
        subject,
        comment,
        entityId,
        programId,
        entityType,
        organizationId
      );
      response.then((res) => {
        this.handleResponseFromServer(res);
      });
    }
  }

  handleResponseFromServer = (res) => {
    if (res !== undefined && res.type === API_COMMENT_POST_SUCCESS) {
      const newComment = res.payload[0];
      var commentList = _.values(this.props.data);
      this.setState({
        subject: emptyStr,
        comment: emptyStr,
        userComments: [newComment, ...commentList],
      });

      this.props.saveEntitySessionData('context.subComment', this.state.userComments);
    }
  };

  render() {
    const {
      header,
      headerSize,
      readOnly,
      allowSubmit,
      defaultHeader,
      subHeader,
    } = this.props;

    let data = _.filter(
      this.props.data,
      (comment) =>
        (!_.includes(EXCLUSIONS, comment.process) && comment && !comment.status) ||
        comment.status == 200
    );

    const defaultHeaderText = defaultHeader
      ? 'Comments'
      : allowSubmit
      ? 'Comments history'
      : 'Comments';
    const commentsHeaderText = this.props.commentsHeaderText || defaultHeaderText;
    const subHeaderText = subHeader
      ? subHeader
      : 'Add additional comments to the subgrant file.';

    return (
      <React.Fragment>
        {header && (
          <Header as={headerSize || 'h1'}>
            {header}
            <Header.Subheader>{subHeaderText}</Header.Subheader>
          </Header>
        )}
        {!readOnly && allowSubmit && (
          <Form onSubmit={this.handleSubmit}>
            <TextBoxField
              value={this.state.subject}
              label="Subject"
              id="subject"
              title={'Required: Subject'}
              name="subject"
              handleChange={this.handleChange}
              handleBlur={this.handleBlur}
              maxLength={65}
            />
            <TextAreaField
              value={this.state.comment}
              label="Comment"
              id="comment"
              title="Required: Comment"
              name="comment"
              maxLength={4000}
              handleChange={this.handleChange}
              handleBlur={this.handleBlur}
            />
            <Form.Field>
              <Button
                primary
                disabled={
                  _.trim(this.state.subject) === emptyStr ||
                  _.trim(this.state.comment) === emptyStr
                }
                title="Submit comment"
              >
                Submit comment
              </Button>
            </Form.Field>
          </Form>
        )}

        <Header as="h3">{commentsHeaderText}</Header>
        <Segment>{this.renderComments(data)}</Segment>
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  saveSubComment: (
    token,
    userId,
    subject,
    comment,
    entityId,
    programId,
    organizationId,
    entityType
  ) => {
    const action = ApiActions.comments.saveSubComment(
      token,
      userId,
      subject,
      comment,
      entityId,
      programId,
      organizationId,
      entityType
    );
    const response = dispatch(action);
    return response;
  },
});

export const mapStateToProps = (state, props) => {
  return {
    token: state.auth.token,
    userId: state.auth.userId,
    grantId: _.get(
      state,
      'dynamicComponent.context.data.entityId',
      _.get(props, 'entityId')
    ),
    organizationId: _.get(
      state,
      'dynamicComponent.context.data.subOrgId',
      getSubOrganizationId(props)
    ),
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(connectDynamic(SubComment));
